import React, { useContext } from "react";
import { BrandContext } from "./BrandContext";

const Error = ({ image, errorMessage }) => {
  const venueBrand = useContext(BrandContext);

  return (
    <div
      className="bg-venue-background max-h-screen overflow-y-hidden"
      style={venueBrand.cssVariables}
    >
      <div className="opacity-100 border-b-2 pb-96 overflow-y-auto mx-auto sm:max-w-sm h-screen bg-white max-w-screen-sm">
        <div className="flex flex-wrap space-y-16 content-center justify-center items-center sm:space-x-32 md:space-x-64 max-w-screen-lg py-16 md:p-32 mx-auto my-32">
          <h3 className="">{errorMessage}</h3>
        </div>
      </div>
    </div>
  );
};

export default Error;
